export const IconLetter = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.91406 8C5.06635 8 2.75781 10.3085 2.75781 13.1562V31.9062C2.75781 34.754 5.06635 37.0625 7.91406 37.0625H37.9141C40.7618 37.0625 43.0703 34.754 43.0703 31.9062V13.1562C43.0703 10.3085 40.7618 8 37.9141 8H7.91406ZM14.3455 15.7542C13.7092 15.3088 12.8324 15.4636 12.387 16.0998C11.9416 16.7361 12.0964 17.6129 12.7326 18.0583L22.1076 24.6208C22.5917 24.9597 23.2364 24.9597 23.7205 24.6208L33.0955 18.0583C33.7317 17.6129 33.8866 16.7361 33.4411 16.0998C32.9958 15.4636 32.1188 15.3088 31.4826 15.7542L22.9141 21.7522L14.3455 15.7542Z"
        fill="white"
      />
    </svg>
  );
};
